import styled from 'styled-components';

const CardButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: inherit;
  position: relative;
  text-align: left;
  width: 100%;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid var(--color-functional-focus);
  }
`;

export default CardButton;
